document.addEventListener('DOMContentLoaded', () => {
  const notifyWrappers = document.querySelectorAll('.course-detail__notify');

  notifyWrappers.forEach((wrapper) => {
    const toggleBtn = wrapper.querySelector('.js-notify-toggle');
    const formPanel = wrapper.querySelector('.course-detail__notify-form');

    if (!toggleBtn || !formPanel) return;

    const courseId   = wrapper.dataset.courseId   || '';
    const courseName = wrapper.dataset.courseName || '';
    // Formidable field IDs are env-specific; the template resolves them from stable
    // keys and passes them here as data attributes.
    const idFieldId   = wrapper.dataset.fieldCourseId   || '';
    const nameFieldId = wrapper.dataset.fieldCourseName || '';

    // Populate hidden fields once (they may not exist until Formidable renders)
    function populateHiddenFields() {
      const idField   = idFieldId   ? formPanel.querySelector(`input[name="item_meta[${idFieldId}]"]`)     : null;
      const nameField = nameFieldId ? formPanel.querySelector(`input[name="item_meta[${nameFieldId}]"]`) : null;
      if (idField)   idField.value   = courseId;
      if (nameField) nameField.value = courseName;
    }

    toggleBtn.addEventListener('click', () => {
      const isHidden = formPanel.getAttribute('aria-hidden') === 'true';

      if (isHidden) {
        formPanel.setAttribute('aria-hidden', 'false');
        toggleBtn.setAttribute('aria-expanded', 'true');
        populateHiddenFields();
        // Focus email input for accessibility
        const emailInput = formPanel.querySelector('input[type="email"]');
        if (emailInput) emailInput.focus();
      } else {
        formPanel.setAttribute('aria-hidden', 'true');
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  });
});
